export const OPEN_ASSISTANT_EVENT = "lazysem:open-assistant";
export function openAssistantSurface(): void {
  window.dispatchEvent(new Event(OPEN_ASSISTANT_EVENT));
}
